// src/components/ui/Marquee.jsx
import React from 'react';

const Marquee = ({ 
  items = [], 
  direction = 'left', 
  speed = 50, 
  pauseOnHover = true,
  separator = ' • ',
  className = '',
  style = {} 
}) => {
  // Si no hay items, no renderizar nada
  if (!items || items.length === 0) {
    return null;
  }

  // Crear múltiples copias para efecto verdaderamente infinito
  const contentItems = [...items, ...items, ...items, ...items];
  
  // Configurar la animación según la dirección
  const animationDirection = direction === 'left' ? 'marquee-left' : 'marquee-right';
  
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`} style={style}>
      <div
        className={`inline-block ${pauseOnHover ? 'hover-pause' : ''}`}
        style={{
          animation: `${animationDirection} ${speed}s linear infinite`,
        }}
      >
        {contentItems.map((item, index) => (
          <React.Fragment key={`${item}-${index}`}>
            <span className="inline-block fraunces text-xl font-semibold">{item}</span>
            {index < contentItems.length - 1 && (
              <span className="mx-2 opacity-60">{separator}</span>
            )}
          </React.Fragment>
        ))}
      </div>
      
      <style>{`
        @keyframes marquee-left {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        
        @keyframes marquee-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0%); }
        }
        
        .hover-pause:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default Marquee;